import ConjunctionCalendarComponent from '@/components/shared/conjunctionCalendar/ConjunctionCalendarComponent';
import GradientBar from '@/components/core/bar/GradientBar';
import { Layout } from './conjunctionCalendarStyle';
import { isMobile } from 'react-device-detect';
import { useState } from 'react';
import ConjunctionSelect from '@/components/core/select/ConjunctionSelect';
import { useConjunctionTable } from '@/components/astroOne/conjunctionTable/body/conjunctionTableHooks';
import { SearchType } from '@/components/astroOne/conjunctionTable/header/Search';
// import CalendarTab from '@/components/calendar/CalendarTab';
import {
  columns,
  headers,
} from '@/components/astroOne/conjunctionTable/body/ConjunctionTable';
import Table from '@/components/ui/table/Table';
import ConjunctionCalendarMobile from './ConjunctionCalendarMobile';
import { CONJUNCTION_TABLE_CONTEXT } from '@/constants/context';

const SELECT_TYPE = 'CALENDAR';

const ConjunctionCalendar = () => {
  const [probabilityInfo] = useState({
    max: 1,
    min: 0.000001,
  });
  const [calendarType] = useState('list');

  const {
    selected,
    setSelected,
    page,
    setPage,
    isLoading,
    isFetching,
    tableData,
    startCollection,
    endCollection,
  } = useConjunctionTable({
    limit: 100,
    queryKey: SearchType.SEARCH,
  });

  if (isMobile) {
    return <ConjunctionCalendarMobile />;
  }

  const CalendarComponent = (
    <section className='w-full h-[calc(100%-3.6rem-3rem)] conjunction-calendar-wrapper min-w-[600px]'>
      <ConjunctionCalendarComponent
        probabilityInfo={probabilityInfo}
        tableData={tableData}
        isLoading={isLoading}
        isFetching={isFetching}
      />
    </section>
  );

  return (
    <>
      <Layout $ismobile={false}>
        <div>

          <div className='flex items-center gap-2'>
            <h3
              style={{ fontSize: '18px' }}
              className='font-semibold text-black m-0'
            >
              {CONJUNCTION_TABLE_CONTEXT.TITLE}
            </h3>
            <div
              style={{ fontSize: '12px' }}
              className='font-medium text-[#6C6C6C] m-0'
            >
              {CONJUNCTION_TABLE_CONTEXT.DESCRIPTION}
            </div>
          </div>
          <div className='flex items-center gap-2'>
            <p
              style={{ fontSize: '12px' }}
              className='font-medium text-[#6C6C6C] m-0'
            >
              Prediction Window :
            </p>
            <p
              style={{ fontSize: '12px' }}
              className='font-medium text-[#6C6C6C] m-0'
            >
              {startCollection} ~ {endCollection} (UTC)
            </p>
          </div>
        </div>
        <section className='flex flex-row justify-between items-center gap-4'>
          <div className='flex flex-col'>
            {/* <CalendarTab calendarType={calendarType} setCalendarType={setCalendarType} /> */}
            <ConjunctionSelect
              selected={selected}
              setSelected={setSelected}
              type={SELECT_TYPE}
            />
          </div>
          <div
            onClick={() => { }}
            className='relative top-0 right-0 py-2 px-3 rounded-md flex whitespace-nowrap items-center gap-2 !text-sm md:!text-base font-medium bg-[#001326] text-white cursor-pointer hover:scale-95'
          >
            Search
            <img
              src='/svg/search-yellow.svg'
              className='w-[1.3rem] h-[1.3rem]'
              alt='search'
            />
          </div>
        </section>

        {calendarType === 'calendar' ? (
          <>
            <>{CalendarComponent}</>
            <section className='relative ml-[90px] mr-5'>
              <GradientBar />
            </section>
          </>
        ) : (
          <section className='h-[calc(100%-3.6rem)] overflow-y-auto my-4 conjunction-list-wrapper'>
            <Table
              headers={headers}
              columns={columns}
              data={tableData}
              page={page}
              setPage={setPage}
              isLoading={isLoading || isFetching}
              totalPages={1}
              limit={100}
            />
          </section>
        )}
      </Layout>
    </>
  );
};

export default ConjunctionCalendar;
